import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import type { ForgotPasswordPayload } from 'services/requests';
import { yupEmail } from 'utils';
import type { UseCustomFormReturn } from './useCustomForm';
import { useCustomForm } from './useCustomForm';

export enum SendEmailFieldNames {
  email = 'email',
}
export const useSendEmailForm = (): UseCustomFormReturn<ForgotPasswordPayload> => {
  const schema: yup.SchemaOf<ForgotPasswordPayload> = yup.object().shape({
    email: yupEmail,
  });

  const resolver = yupResolver(schema);

  const form = useForm<ForgotPasswordPayload>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: { email: '' },
  });

  return useCustomForm(form, resolver);
};
